import { render, staticRenderFns } from "./ProfileTwitterFeed.vue?vue&type=template&id=45b40453&"
import script from "./ProfileTwitterFeed.vue?vue&type=script&lang=js&"
export * from "./ProfileTwitterFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b40453')) {
      api.createRecord('45b40453', component.options)
    } else {
      api.reload('45b40453', component.options)
    }
    module.hot.accept("./ProfileTwitterFeed.vue?vue&type=template&id=45b40453&", function () {
      api.rerender('45b40453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfileTwitterFeed.vue"
export default component.exports